import React from 'react'
import { shape, string } from 'prop-types'

const Placeholder = (props) => {
  const {
    moduleData: { type, contents }, modules, name, moduleId,
  } = props
  const Component = modules[type]
  if (!Component) {
    return null
  }

  return (
    <Component contents={contents} name={name} type={type} moduleId={moduleId} />
  )
}

Placeholder.propTypes = {
  moduleData: shape({ type: string }).isRequired,
  modules: shape({}).isRequired,
  name: string,
  moduleId: string,
  type: string,
}

Placeholder.defaultProps = {
  name: null,
  moduleId: null,
  type: null,
}

export default Placeholder



// WEBPACK FOOTER //
// ./components/cms/components/placeholder.js